<!--  -->
<template>
  <div class="config-container">
    <div class="config-content">
      <div class="st-data-search">
        <!-- <div class="data-left">
          <div class="data-switch">
            <span class="switch-span">数据查询关联</span>
            <a-switch v-model:checked="checked" />
          </div>
          <div class="data-select" v-if="checked">
            <span class="select-span">关联活动查询模板</span>
            <a-select
              v-model:value="switchFormState.activeType"
              placeholder="请选择类型"
              class="switchSelect"
            >
              <a-select-option
                :value="item.id"
                v-for="(item,index) in switchOption"
                :key="item.id"
              >{{item.name}}</a-select-option>
            </a-select>
          </div>
        </div>-->
        <div class="data-btn">
          <a-button type="primary" shape="round" @click="createTemplateChange" :loading="loading">
            <template #icon>
              <span class="btn-span">
                <Icon icon="folder-add-line" />
                <span class="icon-span">提交</span>
              </span>
            </template>
          </a-button>
          <a-button type="dashed" class="exit-btn" @click="goBack">退出</a-button>
        </div>
      </div>
      <div class="config-body">
        <div class="config-tree">
          <a-tree :tree-data="treeData" @select="treeSelect" v-model:selectedKeys="selectedKeys">
            <template #title="{ key: treeKey, title }">
              <a-tooltip placement="leftTop">
                <template #title>{{ title }}</template>
                <span class="icon-title">{{ title }}</span>
              </a-tooltip>
            </template>
          </a-tree>
        </div>
        <div class="config-empty" v-if="!currentForm || currentForm.length < 1">
          <a-empty />
        </div>
        <div class="config-form" v-else>
          <a-form
            ref="generateForm"
            class="configForm"
            :model="model"
            :layout="config.layout"
            :labelAlign="config.labelAlign"
            :labelCol="config.labelCol"
            :hideRequiredMark="config.hideRequiredMark"
          >
            <div v-for="(item,index) in currentForm" :key="index">
              <GenerateFormItem
                v-model:model="model"
                :key="item.key"
                :element="item"
                :config="config"
              />
            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted, watch } from "vue";
import { activeDetail, contentConfig } from "@/api/index.js";
import { useRoute, useRouter } from "vue-router";
import GenerateFormItem from "../../components/generateFormItem.vue";
import { getTreeDataByKey } from "@/utils/index";
import Icon from "@/layout/icon";
import { message } from "ant-design-vue";
// 导入的其他文件 例如：import moduleName from 'modulePath';

export default defineComponent({
  name: "configTree",
  components: {
    GenerateFormItem,
    Icon
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      treeData: [],
      selectedKeys: [],
      currentForm: null,
      model: {},
      checked: false,
      config: {
        size: "default",
        hideRequiredMark: false,
        layout: "horizontal",
        labelAlign: "right",
        readonly: false
      },
      switchOption: [
        {
          id: 0,
          name: "投票"
        },
        {
          id: 1,
          name: "抽奖"
        },
        {
          id: 2,
          name: "答题"
        },
        {
          id: 3,
          name: "邀请"
        },
        {
          id: 4,
          name: "预注册"
        }
      ],
      loading: false,
      rulesType: 0
    });
    // switch
    const switchFormState = reactive({
      activeType: null
    });
    const getTreeData = () => {
      let params = {};
      activeDetail(params, route.query.id).then(res => {
        console.log(res, "resss");
        if (res.status === 200) {
          state.treeData = res.data.activitiesMeta.activitiesNodes;
          state.rulesType = res.data.activitiesMeta.type;
        }
      });
    };
    const treeSelect = (selectedKeys, e) => {
      let selectItem = getTreeDataByKey(state.treeData, selectedKeys?.[0]);
      console.log(selectItem, "selectItem");
      if (selectItem) {
        state.currentForm = selectItem.contents.list;
      }
    };
    const createTemplateChange = () => {
      state.loading = true;
      console.log(state.treeData, "treData");
      let params = {
        activitiesNodes: state.treeData,
        type: state.rulesType
      };
      contentConfig(params, route.query.id).then(res => {
        console.log(res, "res");
        if (res.status === 200) {
          setTimeout(() => {
            state.loading = false;
            message.success("提交成功！").then(() => {
              router.push({
                name: "listItem"
              });
            });
          }, 2000);
        }
      });
    };
    const goBack = () => {
      router.replace({
        name: "listItem"
      });
    };
    watch([state.currentForm], ([newCurrentItem], [preCurrentItem]) => {
      console.log(state.currentForm, "state.currentForm");
    });
    onMounted(() => {
      getTreeData();
    });
    return {
      ...toRefs(state),
      treeSelect,
      switchFormState,
      createTemplateChange,
      goBack
    };
  }
});
</script>
<style lang="less">
.ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
  text-align: left;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import "./index.less";
</style>